import { ANALYTICS_COLOR_4 } from '@/config/constants';
import type { InsightMetricConfig } from './utils';

export const UNIT_TYPE_CURRENCY = 'currency' as const;
export const UNIT_TYPE_PERCENT = 'percent' as const;

export const insightKeys = {
  IMPRESSIONS: 'impressions',
  REACH: 'reach',
  CLICKS: 'clicks',
  CONVERSIONS: 'conversions',
  CONVERSION_VALUE: 'conversion_value',
  SPENT: 'spent',

  CPM: 'cpm',
  CPC: 'cpc',
  CPR: 'cpr',
  CTR: 'ctr',
  ROAS: 'roas',
  FREQUENCY: 'frequency'
} as const;

export const adLevel = {
  ADS: 'ads',
  ADSET: 'adsets',
  CAMPAIGNS: 'campaigns'
} as const;

export const ADS_INSIGHT_CONFIG: InsightMetricConfig[] = [
  {
    key: insightKeys.IMPRESSIONS,
    title: 'Impressions',
    helpText: 'Total ad impressions',
    cssIcon: 'fa-duotone fa-solid fa-eye',
    cssIconColor: ANALYTICS_COLOR_4,
    aggregation: 'sum'
  },
  {
    key: insightKeys.REACH,
    title: 'Reach',
    helpText: 'Unique users reached',
    cssIcon: 'fa-duotone fa-solid fa-users',
    cssIconColor: ANALYTICS_COLOR_4,
    aggregation: 'sum'
  },
  {
    key: insightKeys.CLICKS,
    title: 'Clicks',
    helpText: 'Total clicks',
    cssIcon: 'fa-duotone fa-solid fa-computer-mouse',
    cssIconColor: ANALYTICS_COLOR_4,
    aggregation: 'sum'
  },
  {
    key: insightKeys.SPENT,
    title: 'Spend',
    helpText: 'Total amount spent',
    cssIcon: 'fa-duotone fa-solid fa-wallet',
    cssIconColor: ANALYTICS_COLOR_4,
    aggregation: 'sum',
    unitType: UNIT_TYPE_CURRENCY
  },
  {
    key: insightKeys.CONVERSIONS,
    title: 'Conversions',
    helpText: 'Total conversions',
    cssIcon: 'fa-duotone fa-solid fa-bullseye',
    cssIconColor: ANALYTICS_COLOR_4,
    aggregation: 'sum'
  },
  {
    key: insightKeys.CONVERSION_VALUE,
    title: 'conversion_value',
    helpText: 'Total made from conversions',
    cssIcon: 'fa-duotone fa-solid fa-money-bill',
    cssIconColor: ANALYTICS_COLOR_4,
    aggregation: 'sum',
    unitType: UNIT_TYPE_CURRENCY
  }
];

export const ADS_STATS_CONFIG: InsightMetricConfig[] = [
  {
    key: insightKeys.CTR,
    title: 'CTR',
    helpText: 'Click-through rate (averaged)',
    cssIcon: 'fa-duotone fa-solid fa-percent',
    cssIconColor: ANALYTICS_COLOR_4,
    aggregation: 'average',
    unitType: UNIT_TYPE_PERCENT
  },
  {
    key: insightKeys.CPM,
    title: 'CPM',
    helpText: 'Cost per 1000 impressions (averaged)',
    cssIcon: 'fa-duotone fa-solid fa-chart-line',
    cssIconColor: ANALYTICS_COLOR_4,
    aggregation: 'average',
    unitType: UNIT_TYPE_CURRENCY
  },
  {
    key: insightKeys.CPC,
    title: 'CPC',
    helpText: 'Cost per Click',
    cssIcon: 'fa-duotone fa-solid fa-chart-line',
    cssIconColor: ANALYTICS_COLOR_4,
    aggregation: 'average',
    unitType: UNIT_TYPE_CURRENCY
  },
  {
    key: insightKeys.CPR,
    title: 'CPR',
    helpText: 'Cost per Result',
    cssIcon: 'fa-duotone fa-solid fa-chart-line',
    cssIconColor: ANALYTICS_COLOR_4,
    aggregation: 'average',
    unitType: UNIT_TYPE_CURRENCY
  },
  {
    key: insightKeys.ROAS,
    title: 'ROAS',
    helpText: 'Return on Ad Spend',
    cssIcon: 'fa-duotone fa-solid fa-arrow-trend-up',
    cssIconColor: ANALYTICS_COLOR_4,
    aggregation: 'average'
  },
  {
    key: insightKeys.FREQUENCY,
    title: 'Frequency',
    helpText: 'frequency',
    cssIcon: 'fa-duotone fa-solid fa-percent',
    cssIconColor: ANALYTICS_COLOR_4,
    aggregation: 'average'
  }
];

export const ADS_COMBINED_CONFIG: InsightMetricConfig[] = [
  ...ADS_INSIGHT_CONFIG,
  ...ADS_STATS_CONFIG.filter(
    (s) => !ADS_INSIGHT_CONFIG.some((i) => i.key === s.key)
  )
];
